import { useEffect, useState } from "react";
import {
  CartesianGrid,
  Line,
  LineChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from "recharts";
import { EmptyState } from "../../components/EmptyState";
import { api, type TrendSeries } from "../../lib/api";

export default function TrendsActivity() {
  const [data, setData] = useState<TrendSeries | null | "error">(null);

  useEffect(() => {
    api.trends
      .activity(30)
      .then(setData)
      .catch(() => setData("error"));
  }, []);

  const hasData =
    data !== null && data !== "error" && data.points.length > 0;

  return (
    <div className="animate-fade-in">
      <h2 className="section-title mb-4">Activity</h2>

      {!hasData ? (
        <EmptyState error={data === "error"} title="No activity history yet">
          Steps and active minutes from Garmin and the Galaxy Watch build this
          trend.
        </EmptyState>
      ) : (
        <div className="card card-pad">
          <ResponsiveContainer width="100%" height={280}>
            <LineChart data={data.points}>
              <CartesianGrid
                strokeDasharray="3 3"
                stroke="#e7e5e4"
                vertical={false}
              />
              <XAxis
                dataKey="date"
                axisLine={false}
                tickLine={false}
                fontSize={11}
              />
              <YAxis
                axisLine={false}
                tickLine={false}
                width={36}
                fontSize={11}
                domain={["auto", "auto"]}
              />
              <Tooltip />
              <Line
                type="monotone"
                dataKey="value"
                name="Steps"
                stroke="#9a3412"
                strokeWidth={2}
                dot={false}
                connectNulls
              />
            </LineChart>
          </ResponsiveContainer>
        </div>
      )}
    </div>
  );
}
